import * as React from "react";

import { ExitFullScreenMode, EnterFullScreenModeTooltip } from "VersionControl/Scripts/Resources/TFS.Resources.VersionControl";

export interface IFullScreenButtonProps extends React.Props<void> {
    isFullScreen: boolean;
    toggleFullScreen(): void;
}

/**
 * Rendering a fullscreen button using legacy support for key controls, etc.
 */
export class FullScreenButton extends React.PureComponent<IFullScreenButtonProps, {}> {
    public render(): JSX.Element {
        const fullScreenLabel: string = this.props.isFullScreen ? ExitFullScreenMode : EnterFullScreenModeTooltip;
        const fullScreenIcon: string = this.props.isFullScreen ? "bowtie-icon bowtie-view-full-screen-exit" : "bowtie-icon bowtie-view-full-screen";
        
        return <button
            aria-label={fullScreenLabel}
            title={fullScreenLabel}
            className={"fullscreen clear-button link-button"}
            onClick={this.props.toggleFullScreen} >
            <i className={fullScreenIcon} />
        </button>;
    }
}
